import { request } from "../_helpers/Auth";

const namespace = "/api";

export const getTeamEstablishments = (_id) => {
    return request({
        url: namespace + "/teams/establishment/" + _id,
        method: "get",
    });
};

export const addTeam = (establishment_id, payload) => {
    return request({
        url: namespace + "/establishment/" + establishment_id + "/team",
        method: "post",
        data: payload,
    });
};

// export const editTeam = (establishment_id, payload) => {
//     return request({
//         url: namespace + "/establishment/" + establishment_id + "/team/edit",
//         method: "post",
//         data: payload,
//     });
// };

export const editTeam = (team_id, payload) => {
    return request({
        url: namespace + "/team/" + team_id,
        method: "put",
        data: payload,
    });
};

export const getTeam = (_id) => {
    return request({
        url: namespace + "/team/" + _id,
        method: "get",
    });
};

export const getTeamUsers = (_id) => {
    return request({
        url: namespace + "/team/" + _id + "/users",
        method: "get",
    });
};

export const deleteTeam = (_id) => {
    return request({
        url: namespace + "/team/" + _id,
        method: "delete",
    });
};